import {
  isAndroid,
  isDesktop,
  isIOS,
  isIPad,
  isMobile,
  isSafari,
  isWindows
} from '../../classes/Platform.js'

export function getClientPlatformClassName({ isNative }) {
  const classNames = ['bnClient']

  if (isMobile()) classNames.push('benxtAppMobile')
  if (isIOS()) classNames.push('benxtAppIOS')
  if (isAndroid()) classNames.push('benxtAppAndroid')
  if (isDesktop() || isIPad()) classNames.push('benxtAppDesktop')
  if (isSafari()) classNames.push('benxtAppSafari')
  if (isWindows()) classNames.push('benxtAppWindows')

  classNames.push(isNative ? 'benxtAppNative' : 'benxtAppWeb')

  return classNames.join(' ')
}
